import React from 'react'
import { Link } from 'react-router-dom'

import LogoSymbol from '../../../styles/images/logo-symbol.png'

const Home = () => (
  <Link className="main-menu-item main-menu-item--logo" to="/">
    <img src={LogoSymbol} className="main-menu-logo-img" />
  </Link>
)

export default Home
